import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Form, Row, Spinner } from "react-bootstrap";
import NavBarRedes from "../../components/Redes/NavBarRedes";
import FooterRedes from "../../components/Redes/FooterRedes";
import UserContext from "../../components/user/UserContext";
import { doc, setDoc, db } from "../../services/firestoreApi";
import { StatusCompra } from "../../components/user/StatusCompra";

//Muestra una pantalla que contiene toda la información sobre
// un producto seleccionado previamente
// se accede como /producto
const Producto = () => {

    const { selectedProducto, user, GetCarrito } = useContext(UserContext)
    const [cantidad, setCantidad] = useState(0)
    const [spinnerControler, setSpinnerControler] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const { carrito } = useContext(UserContext)
    const AgregarProducto = async () => {
        if (carrito.data.status === StatusCompra.comprando) {
            if (!isNaN(cantidad) && cantidad > 0) {
                setSpinnerControler(true)
                const total = (cantidad * selectedProducto.data().monto_subsidio).toFixed(2);
                await setDoc(doc(db, "ordenes", user.data.current_orden + "/productos/" + selectedProducto.id),
                    {
                        cantidad: cantidad,
                        foto: selectedProducto.data().foto,
                        name: selectedProducto.data().name,
                        costo_peso_extra: selectedProducto.data().costo_peso_extra,
                        total: total
                    });
                GetCarrito(user.data.current_orden)
                alert("¡Producto agregado a tu canasta!")
                setSpinnerControler(false)



            }
            else
                alert("Elige una cantidad a comprar")
        } else
            alert("No puedes realizar otra compra mientras que la actual está en curso")

    }
    const HandleChange = e => {
        const { value } = e.target
        setCantidad(value)

    }
    return (
        <>
            {user === undefined ?
                <>
                    {window.location.href = "/redes"}
                </>
                :
                <>
                    <NavBarRedes />
                    {selectedProducto !== "" ?


                        <Row xs={1} md={2} className="m-0">
                            <Col>
                                <Container className="my-5 text-center">
                                    <img src={selectedProducto.data().foto} alt="..." className="rounded shadow w-100 img-fluid" />
                                </Container>
                            </Col>
                            <Col>
                                <Container className="my-5 ">
                                    <div className="shadow p-4">
                                        <h3>{selectedProducto.data().name}</h3>
                                        <div className="my-5">
                                            <span>marca: </span>
                                            <h5 className="d-inline" > {selectedProducto.data().marca}</h5>

                                        </div>

                                        <Row>
                                            <Col>
                                                <h5>Monto:</h5>
                                                <br />
                                                <p> ${selectedProducto.data().monto}</p>
                                            </Col>
                                            <Col>
                                                <h5>Subsidio:</h5>
                                                <br />
                                                <p> ${selectedProducto.data().subsidio}</p>
                                            </Col>
                                            <Col>
                                                <h5>Aportación final:</h5>
                                                <br />
                                                <p> ${selectedProducto.data().monto_subsidio}</p>
                                            </Col>

                                        </Row>
                                        <h5 className="mt-4">Cantidad mínima de compra combinada:</h5>
                                        <p>{selectedProducto.data().cant_min} unidades</p>
                                        <div>
                                            <h5 className="mt-4">Descripción</h5>
                                            <p>{selectedProducto.data().description}</p>
                                        </div>
                                        <div>
                                            <h5 className="mt-4">Especificaciones técnicas</h5>
                                            <p>{selectedProducto.data().especificaciones}</p>
                                        </div>

                                        <Row>

                                            {spinnerControler ?
                                                <>
                                                    <div className="text-center my-5">
                                                        <Spinner animation="border" variant="danger" />
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <Col>
                                                        <h5>Cantidad:</h5>
                                                        <Form.Control type="number" onChange={HandleChange} />
                                                    </Col>
                                                    <Col>
                                                        <h5 className="text-white">Agregar</h5>
                                                        <button onClick={() => AgregarProducto()} type="button" className="btn w-100 text-white bg-indigo">

                                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                                width="20" height="20"
                                                                viewBox="0 0 172 172"
                                                                style={{ fill: "#000000" }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ffffff"><path d="M34.04167,21.5c-18.3756,0 -34.04167,14.24068 -34.04167,33.36979c0,13.56279 7.76696,25.443 15.77507,35.04948c8.0081,9.60648 16.86721,17.10203 20.4082,20.22624v0.014h0.014c8.61382,7.56708 20.12826,17.1748 20.12826,17.1748l4.59115,3.83528l4.59115,-3.83528c0,0 7.31869,-6.2539 13.10156,-11.18392c1.65485,2.35449 3.40316,4.606 5.20703,6.64877c6.02426,6.82206 12.63024,12.1057 15.18718,14.23535h0.014c6.352,5.27018 14.79525,11.92578 14.79525,11.92578l4.43718,3.49935l4.43718,-3.49935c0,0 8.44325,-6.6556 14.79525,-11.92578h0.014c2.55694,-2.12965 9.16293,-7.41329 15.18718,-14.23535c6.02391,-6.82207 12.14974,-15.34325 12.14974,-25.8252c0,-14.60129 -12.67244,-25.30729 -26.875,-25.30729c-9.23183,0 -15.41607,3.86463 -19.70833,7.48861c-0.90613,-0.76505 -1.9518,-1.5337 -3.03743,-2.28158c3.83852,-6.68126 6.62077,-14.03688 6.62077,-22.0039c0,-19.12912 -15.66607,-33.36979 -34.04167,-33.36979c-13.56725,0 -21.75895,6.59842 -26.875,11.72982c-5.11605,-5.1314 -13.30776,-11.72982 -26.875,-11.72982zM34.04167,35.83333c11.12604,0 21.20605,11.78581 21.20605,11.78581l5.66895,7.29264l5.66895,-7.29264c0,0 10.08001,-11.78581 21.20605,-11.78581c11.48073,0 19.70833,7.30591 19.70833,19.03646c0,5.07557 -2.40639,11.11801 -6.11686,17.09082c-0.95549,-0.09046 -1.81175,-0.29395 -2.84147,-0.29395c-14.20256,0 -26.875,10.706 -26.875,25.30729c0,1.97545 0.27842,3.85903 0.67188,5.69694c-4.36903,3.75834 -8.8159,7.55624 -11.42187,9.74219c-3.47991,-2.91902 -8.82459,-7.35328 -15.25716,-13.00358l-0.014,-0.014c-3.82976,-3.3783 -11.83217,-10.23459 -18.85449,-18.65853c-7.02756,-8.43023 -12.45768,-18.25964 -12.45768,-25.86719c0,-11.73055 8.2276,-19.03646 19.70833,-19.03646zM98.54167,86c7.2192,0 14.16538,7.46061 14.16536,7.46061l5.54297,6.73275l5.54297,-6.73275c0,0 6.94616,-7.46061 14.16536,-7.46061c7.69878,0 12.54167,4.20425 12.54167,10.97396c0,4.17388 -3.55074,10.6709 -8.55241,16.33496c-4.99636,5.65804 -10.75557,10.32226 -13.60547,12.69564c-4.24053,3.51832 -7.21658,5.85043 -10.09212,8.13249c-2.87117,-2.2786 -5.84065,-4.60322 -10.07812,-8.11849l-0.014,-0.014c-2.84957,-2.37303 -8.60912,-7.03759 -13.60547,-12.69564c-5.00167,-5.66406 -8.55241,-12.16108 -8.55241,-16.33496c0,-6.76971 4.84289,-10.97396 12.54167,-10.97396z"></path></g></g></svg>

                                                            <span> </span>Agregar</button>
                                                    </Col>

                                                </>
                                            }


                                        </Row>
                                    </div>
                                </Container>

                            </Col>
                        </Row>
                        :
                        <>
                            {window.location.href = "/redes"}
                        </>
                    }
                    <FooterRedes />
                </>
            }

        </>
    )
}
export default Producto